import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarClock, Mail, Smartphone, Plus, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../../ui/button';
import { API, txtMain, txtSub } from './nlShared';
import { PlanRow } from './PlanRow';

export const EditorialPlanning = ({ theme, compact = false }) => {
  const light = theme === 'light';
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [newSlot, setNewSlot] = useState('');
  const load = async () => {
    try { setData((await axios.get(`${API}/admin/editorial/plan`, { withCredentials: true })).data); setError(''); }
    catch { setError('Impossible de charger le planning.'); }
  };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!data?.editions.some(e => e.copy_status === 'generating')) return;
    const timer = setInterval(load, 3000);
    return () => clearInterval(timer);
  }, [data]);
  const addEdition = async () => {
    if (!newSlot) return toast.error('Choisissez une date et une heure.');
    try { await axios.post(`${API}/admin/editorial/plan`, { slot: newSlot }, { withCredentials: true }); setNewSlot(''); toast.success('Envoi ajouté au planning'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Ajout impossible.'); }
  };
  if (error) return <div role="alert" data-testid="plan-load-error" className="text-red-500 flex flex-wrap items-center gap-3">{error}<Button data-testid="plan-retry" onClick={load}>Réessayer</Button></div>;
  if (!data) return <p data-testid="plan-loading" className={txtSub(light)}>Chargement du planning…</p>;
  const upcoming = data.editions.filter(e => ['planned', 'skipped'].includes(e.status));
  const past = data.editions.filter(e => !['planned', 'skipped'].includes(e.status));
  return <section data-testid="editorial-planning" className={`min-w-0 space-y-6 ${txtMain(light)}`}>
    <header className="flex flex-wrap justify-between items-start gap-4">
      <div className="min-w-0">
        <h2 data-testid="plan-title" className="text-lg font-bold flex items-center gap-2"><CalendarClock className="text-[#E9641A] shrink-0" size={21} /> Planning des envois automatiques</h2>
        <p data-testid="plan-intro" className={`text-sm mt-2 ${txtSub(light)}`}>Chaque ligne est un rendez-vous : <Mail size={13} className="inline" /> newsletter personnalisée + <Smartphone size={13} className="inline" /> notification commune. Les heures sont en heure de Paris ; un envoi déplacé part dans le quart d’heure qui suit.</p>
      </div>
      <Button data-testid="plan-refresh" variant="outline" onClick={load}><RefreshCw size={15} className="mr-2" /> Actualiser</Button>
    </header>
    <div className="space-y-3" data-testid="plan-upcoming">
      {!upcoming.length && <p data-testid="plan-empty" className={`text-sm ${txtSub(light)}`}>Aucun envoi planifié.</p>}
      {upcoming.map(e => <PlanRow key={e.id} edition={e} topics={data.available_topics} light={light} compact={compact} onChange={load} />)}
    </div>
    {!compact && <div className={`flex flex-wrap items-end gap-3 border-t pt-5 ${light ? 'border-gray-200' : 'border-white/10'}`}>
      <label className="text-sm font-semibold min-w-0">Ajouter un envoi
        <input type="datetime-local" data-testid="plan-new-slot" value={newSlot} onChange={e => setNewSlot(e.target.value)} className={`block mt-1 rounded border p-2 text-sm ${light ? 'bg-white border-gray-200' : 'bg-[#1a0e2e] border-white/15'}`} />
      </label>
      <Button data-testid="plan-add" onClick={addEdition} className="bg-[#E9641A] hover:bg-[#d15310] text-white"><Plus size={15} className="mr-2" /> Ajouter</Button>
    </div>}
    {!compact && past.length > 0 && <div data-testid="plan-past">
      <h3 className="text-sm font-bold mb-3">Derniers envois</h3>
      <div className="space-y-2">{past.map(e => <PlanRow key={e.id} edition={e} topics={[]} light={light} compact onChange={load} />)}</div>
    </div>}
  </section>;
};
